export const truncateTextFromMiddle = (filename, maxLength = 50) => {
    if (filename.length <= maxLength) return filename;
    const extIndex = filename.lastIndexOf('.');
    const ext = filename.slice(extIndex);
    const name = filename.slice(0, extIndex);
    const start = name.slice(0, Math.ceil((maxLength - ext.length - 3) / 2));
    const end = name.slice(-Math.floor((maxLength - ext.length - 3) / 2));
    return `${start}...${end}${ext}`;
};